import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

const INITIAL_SHOW_DELAY = 5000;   // ms (5sec) — wait before showing popup on page load
const REAPPEAR_AFTER_DISMISS = 180000; // ms (3 min) — reappear after user closes it

interface Offer {
  title: string;
  description: string;
  image: string;
  page_link: string;
}

// ── Static offer data — edit this JSON block directly ───────────
const OFFERS_DATA: Offer[] = [
  {
    title: '11+ Summer Intensive Course',
    description: 'This course will be held during the summer holidays Sat 19 Jul to Sun 7 Sep and is intended to give students a final boost before the exams in September.',
    image: 'https://images.unsplash.com/photo-1689326561417-78ad743ff4e2?q=80&w=1041&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    page_link: '/rapid-course'
  }
];

@Component({
  selector: 'app-offer-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offer-banner.component.html',
  styleUrls: ['./offer-banner.component.css']
})
export class OfferBannerComponent implements OnInit, OnDestroy {
  offer: Offer | null = null;
  visible = false;

  private showTimer: any = null;
  private reappearTimer: any = null;

  ngOnInit() {
    this.offer = OFFERS_DATA.length ? OFFERS_DATA[0] : null;

    if (this.offer) {
      this.showTimer = setTimeout(() => {
        this.visible = true;
      }, INITIAL_SHOW_DELAY);
    }
  }

  // ── User dismisses — reappears after 3 minutes ──────────────────
  dismiss() {
    this.visible = false;
    this.reappearTimer = setTimeout(() => {
      this.visible = true;
    }, REAPPEAR_AFTER_DISMISS);
  }

  // ── Click → navigate ─────────────────────────────────────────
  onBannerClick() {
    if (!this.offer) { return; }
    const link = this.offer.page_link;
    if (!link) { return; }
    if (link.indexOf('/') === 0) {
      window.location.href = link;
    } else {
      window.open(link, '_blank');
    }
  }

  imageSrc(): string {
    if (this.offer && this.offer.image) { return this.offer.image; }
    return 'assets/images/default-offer.png';
  }

  ngOnDestroy() {
    if (this.showTimer) { clearTimeout(this.showTimer); }
    if (this.reappearTimer) { clearTimeout(this.reappearTimer); }
  }
}